import { METER_TYPE_ERROR_CODES } from 'config/app-config';
import { anyTrue } from 'utils/misc';

const {
  MeterMeasurementClassException,
  MHHSUnmeteredSuppliesException,
  MeterProfileClassException,
  MHHSMeterProfileClassException,
  MeterDeenergisedException,
  MeterCurrentSupplierNEPException,
  MeterCurrentSupplierBGREException,
  MeterRelatedException
} = METER_TYPE_ERROR_CODES;

export const useIsExistingCustomer = ({ errors }) => {
  const checkError = (keyword, errorCode) => {
    // these errros should prevent showing the change tariff card
    const excludedErrorCodes = [
      MeterMeasurementClassException,
      MHHSUnmeteredSuppliesException,
      MeterProfileClassException,
      MHHSMeterProfileClassException,
      MeterDeenergisedException,
      MeterRelatedException
    ];

    const fuelErrors = errors?.filter((error) => error.keyword === keyword);

    if (!fuelErrors?.length) {
      return false;
    }

    const hasExcludedError = fuelErrors?.some((error) =>
      excludedErrorCodes.includes(error.code)
    );

    return (
      !hasExcludedError && fuelErrors?.some((error) => error.code === errorCode)
    );
  };

  const result = {
    isExistingNEPCustomer: {
      gas: checkError('Gas', MeterCurrentSupplierNEPException),
      electric: checkError('Electricity', MeterCurrentSupplierNEPException)
    },
    isExistingBGCustomer: {
      gas: checkError('Gas', MeterCurrentSupplierBGREException),
      electric: checkError('Electricity', MeterCurrentSupplierBGREException)
    }
  };

  const isExistingCustomer =
    anyTrue(result.isExistingNEPCustomer) ||
    anyTrue(result.isExistingBGCustomer);
  return {
    ...result,
    isExistingCustomer
  };
};
